import React, { useEffect, useRef, useState } from "react";
import { setRightBottomReserved } from "./animation";
import {
  rendererKind,
  setPreferredRenderer,
  RENDERER_SVG,
  RENDERER_WEBGL,
} from "./render";

// Switches between the WebGL and SVG backends. Provisional: it exists so the two
// can be compared side by side on the same estate while the WebGL renderer beds
// in, and reloads to do it, because rebuilding every object's drawing in place
// would also have to rebuild the meters, page-switch animations and callout
// tracks their enter handlers set up.

// Matches the filter panel's own clearance on the other side, so a callout never
// sits flush against the strip.
const STRIP_CLEARANCE = 14;

const styles = {
  button: {
    position: "absolute",
    right: 0,
    bottom: 0,
    zIndex: 1000,
    padding: "4px 8px",
    border: "none",
    borderTopLeftRadius: "6px",
    background: "rgba(0, 0, 0, 0.55)",
    color: "#eee",
    font: "11px/1.45 Consolas, monospace",
    cursor: "pointer",
  },
};

const RendererToggle = () => {
  const [kind, setKind] = useState(rendererKind);
  const buttonRef = useRef(null);

  // The renderer is created in an effect, and WebGL may have fallen back to SVG
  // on the way, so what is actually running is only known after mount.
  useEffect(() => setKind(rendererKind()), []);

  // Keeps the right-hand callout column clear of the bottom strip. This button
  // stands in for the whole strip: the frame-rate readout and the effects cog sit
  // beside it at the same height, so its own is the height to hold back.
  useEffect(() => {
    const element = buttonRef.current;
    if (!element) return undefined;

    setRightBottomReserved(element.offsetHeight + STRIP_CLEARANCE);
    return () => setRightBottomReserved(0);
  }, []);

  const next = kind === RENDERER_WEBGL ? RENDERER_SVG : RENDERER_WEBGL;

  return (
    <button
      ref={buttonRef}
      type="button"
      style={styles.button}
      title={"Switch to the " + next.toUpperCase() + " renderer (reloads)"}
      onClick={() => setPreferredRenderer(next)}
    >
      {kind === RENDERER_WEBGL ? "renderer: WebGL" : "renderer: SVG"}
    </button>
  );
};

export default RendererToggle;
